import React from 'react';
import cx from 'classnames';
import styles from '../organization.module.css';

export const OptionCard = ({ label, description, selected, onClick }) => (
  <div
    className={cx(styles.optionCard, selected && styles.optionCardSelected)}
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => e.key === 'Enter' && onClick()}
  >
    <div className={styles.optionCardContent}>
      <span className={styles.optionLabel}>{label}</span>
      {description && <span className={styles.optionDescription}>{description}</span>}
    </div>
    <div className={styles.optionRadio} />
  </div>
);
